import { useEffect } from "react";
import { useSetAtom } from "jotai";
import { pageHeaderAtom } from "@/store/ui";

interface PageHeaderOptions {
  title: string;
  breadcrumbs?: Array<{ label: string; to?: string }>;
}

/**
 * Sets the page title and breadcrumbs in the global header atom.
 * Call at the top of each page component.
 *
 * @example
 *   usePageHeader({ title: "Dashboard" });
 *   usePageHeader({ title: "Orders", breadcrumbs: [{ label: "Dashboard", to: "/dashboard" }, { label: "Orders" }] });
 */
export function usePageHeader({ title, breadcrumbs }: PageHeaderOptions) {
  const setHeader = useSetAtom(pageHeaderAtom);

  useEffect(() => {
    setHeader({ title, breadcrumbs });
  }, [title, breadcrumbs, setHeader]);
}
